import React, { useState, useRef } from "react";
import TextInput from "../../layout/TextInput";
import * as subscriptionService from "../../actions/subscription.actions";
import { INFORMATION_PAGE, SERVER_DOWN } from "../../Constants";
import QRCode from "react-qr-code";

export default function PairingForm({
  viewersList,
  setViewersList,
  sendPairingRequest,
  enableMultiThreadedStream,
  setEnableMultiThreadedStream,
  setStream,
  subscriptionType,
  me,
}) {
  const [pairingRequestSent, setPairingRequestSent] = useState(false);
  const [pinError, setPinError] = useState(false);
  const pairButtonRef = useRef("");

  const isPairingPinValid = () => {
    const validList = viewersList.filter((v) => v && v.length >= 7);
    if (validList.length > 0) {
      return true;
    }
    return false;
  };

  const initPairingRequest = async () => {
    if (!pairingRequestSent && isPairingPinValid()) {
      setPairingRequestSent(true);
      const paringRequest = await sendPairingRequest(pairButtonRef);
      if (paringRequest && !paringRequest.result) {
        setPairingRequestSent(false);
      }
    }
  };

  const inputHandler = (event) => {
    if (event.target.value.length !== 0 && event.target.value.length !== 7) {
      setPinError(true);
    } else {
      setPinError(false);
    }
    const updatedViewerList = [...viewersList];
    updatedViewerList[event.target.id] = event.target.value.trim();
    setViewersList(updatedViewerList);
  };

  const handleToggleStreamThreading = async () => {
    if (subscriptionType === "gold" && !pairingRequestSent) {
      setEnableMultiThreadedStream((prev) => {
        setViewersList((prev) => {
          return [prev[0], "", ""];
        });
        return !prev;
      });
      setStream((existingStream) => {
        if (existingStream) {
          // Check if stream is from agoraSDK
          if (existingStream._ID) {
            existingStream.close();
          } else {
            existingStream?.getTracks()[0]?.stop();
          }
        }
        return null;
      });
    } else {
      const response = await subscriptionService.manageSubscription();

      if (!response) {
        console.log(SERVER_DOWN);
        return;
      }

      if (response.data.success) {
        window.open(response.data.url);
      }
    }
  };

  return (
    <div className="paddingtop20">
      {subscriptionType !== "gold" && (
        <h5>
          ~~~~~~~ Locked{" "}
          <span>
            <i class="fa-left-padding fa-solid fa-lock"></i>
          </span>
          {"  "}
          ~~~~~~~
        </h5>
      )}
      <div style={{ color: subscriptionType !== "gold" ? "grey" : "" }}>
        <div id="multi-threaded-stream-swich" className="flexWrapper">
          <h4 className="">Enable multi-threaded stream: </h4>
          <i
            id="streamThreadingSelector"
            onClick={handleToggleStreamThreading}
            className={
              enableMultiThreadedStream
                ? "fa-solid fa-large fa-toggle-on"
                : "fa-solid fa-large fa-toggle-off"
            }
          ></i>{" "}
        </div>
      </div>
      <h5 className="font-weight-normal">
        Single-threaded - best for stream quality (optimised for iOS devices)
      </h5>
      ~~~~~~~
      <h5 className="font-weight-normal">
        Multi-threaded - best for stream reliability
      </h5>
      <div
        className="paddingtop20"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <QRCode
          id="qr-code-display"
          className="pairingItem"
          value={`${process.env.REACT_APP_FE_HOST}/view/?${enableMultiThreadedStream}#${me}`}
        />
        <div className="pairingItem">
          <TextInput
            value={viewersList[0]}
            className={"pairing-pin-input"}
            disabled={pairingRequestSent}
            id={0}
            errorText="Please enter a pairing pin with 7 characters"
            isError={pinError}
            placeholder="Pairing Pin for Viewer 1"
            onChange={inputHandler}
          />
          {enableMultiThreadedStream && (
            <>
              <TextInput
                value={viewersList[1]}
                disabled={pairingRequestSent}
                id={1}
                type="text"
                isError={pinError}
                placeholder="Pairing Pin for Viewer 2"
                onChange={inputHandler}
              />
              <TextInput
                value={viewersList[2]}
                disabled={pairingRequestSent}
                id={2}
                isError={pinError}
                placeholder="Pairing Pin for Viewer 3"
                onChange={inputHandler}
              />
            </>
          )}
          <a
            id="pair-btn"
            href="#"
            ref={pairButtonRef}
            className="buttonPrimary bouncy"
            onClick={initPairingRequest}
          >
            Pair
          </a>
          <div className="paddingtop20">
            <a href={INFORMATION_PAGE}>How to use?</a>
          </div>
        </div>
      </div>
    </div>
  );
}
